<template>
  <div class="screen-main">
    <div class="type-title">
      <div class="title-item" v-for="(item, index) in titleData" :key="index">
        <div class="text-img">
          <div
            class="img-icon"
            :style="{
              backgroundImage: `url(${require(`../../assets/img/largeScreen/${item.icon}.png`)})`,
            }"
          ></div>
          <div class="risk-num" @click="changeRiskLevel(item.level)">
            <label>{{ $l(item.title) }}</label>
            <span>
              <em>
                <count-to
                  :startVal="0"
                  :endVal="item.num"
                  :duration="2000"
                  :decimals="0"
                >
                </count-to
              ></em>
              <i>{{ $l("例") }} </i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="risk-list">
      <el-carousel
        :autoplay="autoplay"
        :interval="interval"
        ref="riskCarousel"
        @change="chnageCarousel"
      >
        <el-carousel-item
          :name="'' + index"
          v-for="(item, index) in riskLists"
          :key="index"
        >
          <div class="carousel-box">
            <template v-if="currentCarouselData.length != 0">
              <screen-monitor-item
                v-for="t in currentCarouselData"
                :key="t.jobNum"
                :riskData="t"
                :isRiskPage="true"
                :screenWatch="screenWatch"
                @click.native="skipLift(t)"
              ></screen-monitor-item>
            </template>
            <template v-else-if="noData">
              <div class="not-data">{{ $l("暂无数据") }}</div>
            </template>
            <template v-else>
              <screen-loading :loading="true" height="100%" width="100%">
              </screen-loading>
            </template>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="risk-bottom" v-show="!noData">
        <!-- <span style="color: #fff"> {{ pagesIndex }}---{{ currentPage }}</span> -->
        <div class="indicators">
          <span v-show="riskLists > 1" @click="clickChange(false)">
            <svgicon name="indicatorsArrow" />
          </span>
          <div>
            <i
              :class="{ 'i-active': i == carouselIndex }"
              v-for="(t, i) in riskLists"
              :key="t"
              @click="clickChange(i)"
            ></i>
          </div>
          <span v-show="riskLists > 1" @click="clickChange(true)">
            <svgicon name="indicatorsArrow" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import screenMonitorItem from "@/components/screenMonitorItem.vue";
import countTo from "vue-count-to";
import screenLoading from "../../components/screenLoading.vue";
export default {
  name: "displayRiskMonitor",
  data() {
    return {
      titleData: [
        {
          icon: "riskIconSum",
          title: this.$l("风险总数"),
          code: "riskTotal",
          level: 1,
          num: 0,
        },
        {
          icon: "riskIconTall",
          title: this.$l("最高风险"),
          code: "highRiskCount",
          level: 2,
          num: 0,
        },
        {
          icon: "riskIconCentre",
          title: this.$l("中等风险"),
          code: "mediumRiskCount",
          level: 3,
          num: 0,
        },
        {
          icon: "riskIconBass",
          title: this.$l("低等风险"),
          code: "lowRiskCount",
          level: 4,
          num: 0,
        },
      ],
      pageDotNum: 3,
      carouselIndex: 0,
      autoplay: true,
      interval: 30000,
      screenWatch: Date.now(),
      riskLoading: false,
      total: 0, //总数据
      pages: 1, //总共页数
      pagesIndex: 0, //当前所有页
      totalData: [],
      currentPage: 1,
      isManual: true,
      noData: false,
      riskLevel: 0,
    };
  },
  components: {
    countTo,
    screenLoading,
    screenMonitorItem,
  },
  computed: {
    currentCarouselData() {
      if (this.totalData[this.pagesIndex]) {
        return this.totalData[this.pagesIndex];
      } else return [];
    },
    riskLists() {
      return this.pages > this.pageDotNum ? this.pageDotNum : this.pages;
    },
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.total = 0;
      this.pages = 1;
      this.carouselIndex = 0;
      this.totalData = [];
      this.pagesIndex = 0;
      this.currentPage = 1;
      this.isManual = true;
      this.noData = false;
      this.autoplay = false;
      this.getRiskData(true);
    },
    $browserWidthChange() {
      this.screenWatch = Date.now();
    },
    clickChange(direction, isCarousel) {
      this.isManual = true;
      this.autoplay = false;
      const getData = () => {
        if (this.currentCarouselData.length != 0 || this.noData) {
          this.$nextTick(() => {
            this.isManual = false;
            this.autoplay = true;
          });
          return false;
        }
        this.getRiskData();
      };
      const handlePage = () => {
        let remainder = this.pages % this.riskLists;
        let maxPage = Math.floor(this.pages / this.riskLists) + remainder;
        this.currentPage = Math.ceil((this.pagesIndex + 1) / this.riskLists);
        if (this.pagesIndex < 0) {
          this.pagesIndex = this.pages - 1;
          this.currentPage = maxPage;
        } else if (this.pagesIndex + 1 > this.pages) {
          this.pagesIndex = 0;
          this.currentPage = 1;
        }
        // console.log(this.pagesIndex, this.currentPage, maxPage);
        getData();
      };
      if (typeof direction == "number") {
        // if (this.carouselIndex == direction) return false;
        !isCarousel && this.$refs.riskCarousel.setActiveItem(direction);
        this.pagesIndex =
          this.currentPage * this.riskLists - (this.riskLists - direction);
        getData();
        return;
      }
      if (direction) {
        !isCarousel && this.$refs.riskCarousel.next();
        this.pagesIndex++;
        handlePage();
      } else {
        !isCarousel && this.$refs.riskCarousel.prev();
        this.pagesIndex--;
        handlePage();
      }
    },
    chnageCarousel(data) {
      let worn = this.carouselIndex;
      this.carouselIndex = data;
      if (this.isManual) return false;
      if (worn == this.riskLists - 1 && data == 0) {
        this.clickChange(true, true);
      } else {
        this.clickChange(data, true);
      }
    },
    getRiskData(init) {
      this.riskLoading = true;
      this.$http
        .post(this.$apiConfig.get_risk_fault, {
          pageNum: this.pagesIndex + 1,
          pageSize: 6,
          riskLevel: this.riskLevel,
        })
        .then((response) => {
          let result = response.data;
          this.riskLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          const { pages, total, result: dataResult, pageNum } = data;
          // console.log("pageNum", pageNum);
          this.titleData.forEach((v) => (v.num = data[v.code]));
          // if (init) this.pages = pages || 0;
          if (init) this.noData = dataResult.length == 0;
          this.pages = pages || 0;
          this.total = total || 0;
          this.$set(this.totalData, pageNum - 1, dataResult);
          this.autoplay = true;
          this.isManual = false;
        })
        .catch((error) => {
          this.autoplay = true;
          this.isManual = false;
          this.riskLoading = false;
          this.$sentry.captureException(error);
        });
    },
    changeRiskLevel(le) {
      this.riskLevel = le;
      this.initData();
    },
    skipLift(data) {
      const { jobNum } = data;
      this.$router.push({
        name: "deviceBigScreen",
        params: { jobNum },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-main {
  flex: 1;
  position: relative;
  background: url(../../assets/img/largeScreen/riskMonitorBgc.jpg) no-repeat;
  background-size: 100% 100%;
  display: flex;
  padding: vh(35) vw(15) 0 vw(15);
  flex-direction: column;
}
.type-title {
  height: vh(172);
  background: rgba(5, 25, 53, 0.6);
  border-radius: 6px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.risk-list {
  flex: 1;
  background: rgba(5, 25, 53, 0.6);
  border-radius: 6px 6px 0 0;
  margin-top: vh(12);
  display: flex;
  flex-direction: column;
}
.title-item {
  flex: 0.24;
  &:nth-child(2) {
    .risk-num span {
      color: #e3673f;
    }
  }
  &:nth-child(3) {
    .risk-num span {
      color: #ffb900;
    }
  }
  &:nth-child(4) {
    .risk-num span {
      color: #01d3a9;
    }
  }
  .text-img {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-icon {
    width: vw(140);
    height: vw(142);
    // background: url(../../assets/img/largeScreen/riskIconSum.png) no-repeat;
    background-size: cover;
  }
  .risk-num {
    display: flex;
    flex-direction: column;
    margin-left: vw(30);
    padding-top: vh(15);
    label {
      color: #50e0ff;
      font-size: 1.125rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 500;
    }
    span {
      font-size: 3.9375rem;
      font-family: DINCond-Bold;
      font-weight: 400;
      color: #50e0ff;
    }
    i {
      font-size: 1.125rem;
      font-family: AlibabaPuHuiTi;
      font-style: normal;
      font-weight: 500;
      color: #f7faff;
      margin-left: vw(10);
    }
  }
}
.carousel-box {
  width: 100%;
  height: 100%;
  padding: vh(30) vw(15) 0;
  display: flex;
  flex-wrap: wrap;
}
.risk-bottom {
  height: vh(95);
  display: flex;
  align-items: center;
  justify-content: center;
  .indicators {
    display: flex;
    div {
      display: flex;
      align-items: center;
      margin: 0 vw(100);
    }
    i {
      width: vw(8);
      height: vw(8);
      background: rgba(229, 229, 229, 0.3);
      border-radius: 50%;
      margin: 0 vw(8);
      cursor: pointer;
      &:hover {
        background-color: #50e0ff;
      }
    }
    .i-active {
      background-color: #50e0ff;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: vw(16);
        height: vw(16);
        border: 2px solid #50e0ff;
        border-radius: 50%;
      }
    }
    span {
      width: vw(48);
      height: vw(48);
      border: 2px solid #50e0ff1a;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .svg-icon {
        width: vw(26);
        height: vw(26);
        fill: #50e0ff1a;
      }
      &:first-child {
        transform: rotate(180deg);
      }
      &:hover {
        border-color: #50e0ff;
        .svg-icon {
          fill: #50e0ff;
        }
      }
    }
  }
}
/deep/.el-carousel {
  flex: 1;
  .el-carousel__container {
    height: 100%;
  }
  .el-carousel__item {
    height: 100%;
  }
  .el-carousel__arrow {
    display: none;
  }
  .el-carousel__indicators {
    display: none;
  }
}
.not-data {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AlibabaPuHuiTi;
  font-weight: 400;
  font-style: normal;
  font-size: 0.875rem;
  color: #b9ccdf;
}
</style>